import { AppDataState } from './app-data-store';
import { UserInfo } from './interface/user-info';

export const SET_USER_INFO = 'SET_USER_INFO';
export const CLEAR_USER_INFO = 'CLEAR_USER_INFO';

export type SetUserInfoAction = {
  type: typeof SET_USER_INFO;
  payload: UserInfo;
};

// redux update store action
export const setUserInfo = (payload: UserInfo): SetUserInfoAction => {
  return {
    type: SET_USER_INFO,
    payload,
  };
};

// redux reducer handler - state updater
export const setUserInfoHandler = (
  state: AppDataState,
  action: SetUserInfoAction
): AppDataState => {
  return {
    ...state,
    userInfo: action.payload,
  };
};
